import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonRouteComponent } from "./sidebar-button-route.component";

@Component({
    selector: "sidebar-friends",
    imports: [],
    templateUrl: "./sidebar-button-route.component.html"
})
export class SidebarFriendsButtonComponent extends SidebarButtonRouteComponent {
    public constructor() { 
        super("Friends", SvgIcon.Friends, "friends", false); 
    }
}